<template>
  <div>
    <v-card
      color="white"
      flat
      tile
      height="450"
      :max-width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
      :width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
    >
      <v-img height="200" :src="offer.imageurl">
        <div class="fill-height bottom-gradient"></div>
      </v-img>

      <div class="py-4 text-left">
        <v-card
          flat
          color="transparent"
          class="text-h5 font-weight-bold black--text overflow-hidden"
          height="65"
        >
          {{ offer.packagename }}
        </v-card>
        <div class="d-flex align-center">
          <hm-icon>
            <size-icon></size-icon>
          </hm-icon>

          <div
            class="ml-1 lighten-2 text-body-1"
            :class="{ 'price--text': !offer.status }"
          >
            {{ offer.status ? "Available" : "Sold Out" }}
          </div>
        </div>
        <div class="price--text font-weight-bold">
          <span class="text-h5 mr-1 font-weight-bold">{{
            formatMoney(offer.amount)
          }}</span>
          <span>per Plot</span>
        </div>
      </div>

      <div class="d-flex justify-start pb-8 mt-5">
        <v-btn
          @click="togglePaymentMethodDialog(true)"
          depressed
          :disabled="!offer.status"
          tile
          color="secondary"
          class="text-none px-5 py-5 mr-3 text-h6"
          >{{ offer.status ? "Buy" : "Sold Out" }}</v-btn
        >
        <v-btn
          tile
          depressed
          outlined
          color="primary"
          class="text-none px-5 py-5 text-h6"
          @click="toggleLandbankDrawer"
          >About</v-btn
        >
      </div>
    </v-card>
    <landbank-dialog
      @openPaystack="paystackOpen"
      :paymentDialog="paymentDialog"
      :toggleLandbankDialog="togglePaymentMethodDialog"
      :landbank="offer"
      :isOnboarding="isOnboarding"
    />
    <hm-paystack
      :isOpen="isPaystackOpen"
      :paystackCallback="paystackCallback"
      :paystackClose="paystackClose"
      :totalAmount="totalAmount"
      :reference="reference"
      :paymentChannel="selectedPaymentMethod"
    />
  </div>
</template>

<script>
import HmIcon from "@/components/HmIcon";
import SizeIcon from "@/components/icons/landbank/SizeIcon";
import LandbankDialog from "./LandbankDialog";
import HmPaystack from "./../HmPaystack.vue";
import { formatMoney } from "@/utils/helpers";
import { TransactionService } from "@/services/index.js";

export default {
  components: {
    HmIcon,
    SizeIcon,
    LandbankDialog,
    HmPaystack,
  },
  props: {
    offer: {
      type: Object,
    },
    isOnboarding: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formatMoney,
      drawer: null,
      paymentDialog: null,
      isPaystackOpen: false,
      totalAmount: 0,
      reference: "",
      selectedPaymentMethod: "",
    };
  },
  methods: {
    toggleLandbankDrawer() {
      this.$store.commit("toggleDrawer", {
        type: "landbank",
        value: true,
        entity: this.offer,
      });
    },
    togglePaymentMethodDialog(value) {
      this.paymentDialog = value;
    },
    async paystackCallback(res) {
      try {
        const { reference } = res;

        const { message } = await TransactionService.verify(
          reference,
          this.offer.id,
          "investments",
          "0"
        );

        this.isPaystackOpen = false;
        this.$store.commit("openSnackbar", message);
        this.togglePaymentMethodDialog(false);
      } catch (error) {}
    },
    paystackClose() {
      this.isPaystackOpen = false;
    },
    async paystackOpen(form) {
      try {
        this.selectedPaymentMethod = form.channel;

        const reference = await TransactionService.initiatePayment({
          entity: "investments",
          packageid: form.packageid,
          slots: form.units,
        });

        this.reference = reference.reference;

        this.totalAmount = form.total;
        this.isPaystackOpen = true;
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.price--text {
  color: #de6944;
}
</style>
